import Vue from 'vue';
import Router, { Route } from 'vue-router';
import { capitalize } from './utils';
import { PROFILE_CONTENT } from '@/const';
Vue.use(Router);

type IRouteType = 'list' | 'detail' | 'tree';

const component = (name: string, type: IRouteType = 'list') => ({
  component: () => import(
    `@/views/${capitalize(name)}/${capitalize(name)}${capitalize(type)}.vue`
  ),
});

export const routes = [
  {
    name: 'Заявки',
    icon: 'mdi-file-multiple',
    root: {
      path: '/заявки',
      name: 'ProposalList',
      meta: { icon: 'mdi-file-multiple', title: 'Заявки' },
      ...component('Proposal'),
    },
    subRoutes: [
      {
        path: '/заявки/статусы',
        name: 'ProposalStatusList',
        meta: { title: 'Статусы' },
        ...component('ProposalStatus'),
      },
    ],
    routes: [
      {
        path: '/',
        name: '',
        redirect: { name: 'ContractorList' },
      },
      {
        path: '/заявки/статусы/добавить',
        name: 'ProposalStatusCreate',
        ...component('ProposalStatus', 'detail'),
      },
      {
        path: '/заявки/статусы/:id',
        name: 'ProposalStatusDetail',
        ...component('ProposalStatus', 'detail'),
      },
      {
        path: '/заявки/добавить',
        name: 'ProposalCreate',
        meta: { icon: 'mdi-pencil', title: 'Заявки' },
        ...component('Proposal', 'detail'),
      },
      {
        path: '/заявки/:id',
        name: 'ProposalDetail',
        ...component('Proposal', 'detail'),
      },
    ],
  },
  {
    name: 'Проекты',
    icon: 'mdi-folder-multiple',
    root: {
      path: '/проекты',
      name: 'ProjectList',
      ...component('Project'),
    },
    subRoutes: [
      {
        path: '/проекты/календарь',
        name: 'ProjectCalendarList',
        meta: { title: 'Календарь' },
        ...component('ProjectCalendar'),
      },
      {
        path: '/проекты/виды-работ',
        name: 'ProjectLaborTypeList',
        meta: { title: 'Виды работ' },
        ...component('ProjectLaborType'),
      },
      {
        path: '/проекты/статусы',
        name: 'ProjectStatusList',
        meta: { title: 'Статусы' },
        ...component('ProjectStatus'),
      },

    ],
    routes: [
      {
        path: '/проекты/добавить',
        name: 'ProjectCreate',
        ...component('Project', 'detail'),
      },
      {
        path: '/проекты/:id',
        name: 'ProjectDetail',
        ...component('Project', 'detail'),
      },
      {
        path: '/проекты/виды-работ/добавить',
        name: 'ProjectLaborTypeCreate',
        ...component('ProjectLaborType', 'detail'),
      },
      {
        path: '/проекты/виды-работ/:id',
        name: 'ProjectLaborTypeDetail',
        ...component('ProjectLaborType', 'detail'),
      },
      {
        path: '/проекты/статусы/добавить',
        name: 'ProjectStatusCreate',
        ...component('ProjectStatus', 'detail'),
      },
      {
        path: '/проекты/статусы/:id',
        name: 'ProjectStatusDetail',
        ...component('ProjectStatus', 'detail'),
      },
    ],
  },
  {
    name: 'Договоры',
    icon: 'mdi-file-edit',
    root: {
      path: '/договоры',
      name: 'AgreementList',
      ...component('Agreement'),
    },
    subRoutes: [
      {
        path: '/договоры/статусы',
        name: 'AgreementStatusList',
        meta: { title: 'Статусы' },
        ...component('AgreementStatus'),
      },
      {
        path: '/договоры/типы',
        name: 'AgreementTypeList',
        meta: { title: 'Типы' },
        ...component('AgreementType'),
      },
    ],
    routes: [
      {
        path: '/договоры/добавить',
        name: 'AgreementCreate',
        ...component('Agreement', 'detail'),
      },
      {
        path: '/договоры/:id',
        name: 'AgreementDetail',
        ...component('Agreement', 'detail'),
      },
      {
        path: '/договоры/статусы/добавить',
        name: 'AgreementStatusCreate',
        ...component('AgreementStatus', 'detail'),
      },
      {
        path: '/договоры/статусы/:id',
        name: 'AgreementStatusDetail',
        ...component('AgreementStatus', 'detail'),
      },
      {
        path: '/договоры/типы/добавить',
        name: 'AgreementTypeCreate',
        ...component('AgreementType', 'detail'),
      },
      {
        path: '/договоры/типы/:id',
        name: 'AgreementTypeDetail',
        ...component('AgreementType', 'detail'),
      },
    ],
  },
  {
    name: 'Платежи',
    icon: 'mdi-cash-register',
    root: {
      path: '/платежи',
      name: 'PaymentList',
      ...component('Payment'),
    },
    subRoutes: [
      {
        path: '/платежи/статусы',
        name: 'PaymentStatusList',
        meta: { title: 'Статусы' },
        ...component('PaymentStatus'),
      },
    ],
    routes: [
      {
        path: '/платежи/статусы/добавить',
        name: 'PaymentStatusCreate',
        ...component('PaymentStatus', 'detail'),
      },
      {
        path: '/платежи/статусы/:id',
        name: 'PaymentStatusDetail',
        ...component('PaymentStatus', 'detail'),
      },
      {
        path: '/платежи/добавить',
        name: 'PaymentCreate',
        ...component('Payment', 'detail'),
      },
      {
        path: '/платежи/:id',
        name: 'PaymentDetail',
        ...component('Payment', 'detail'),
      },
    ],
  },
  {
    name: 'Контрагенты',
    icon: 'mdi-contacts',
    root: {
      path: '/контрагенты',
      name: 'ContractorList',
      ...component('contractor'),
    },
    subRoutes: [
      {
        path: '/контрагенты/типы',
        name: 'CompanyTypeList',
        meta: { title: 'Типы' },
        ...component('CompanyType'),
      },
      {
        path: '/контрагенты/атрибуты',
        name: 'BankAttributeList',
        meta: { title: 'Атрибуты' },
        ...component('BankAttribute'),
      },
      {
        path: '/контрагенты/представители',
        name: 'RepresentativeList',
        meta: { title: 'Представители' },
        ...component('Representative'),
      },
    ],
    routes: [
      {
        path: '/контрагенты/представители/добавить',
        name: 'RepresentativeCreate',
        ...component('Representative', 'detail'),
      },
      {
        path: '/контрагенты/представители/:id',
        name: 'RepresentativeDetail',
        ...component('Representative', 'detail'),
      },
      {
        path: '/контрагенты/атрибуты/добавить',
        name: 'BankAttributeCreate',
        ...component('BankAttribute', 'detail'),
      },
      {
        path: '/контрагенты/атрибуты/:id',
        name: 'BankAttributeDetail',
        ...component('BankAttribute', 'detail'),
      },
      {
        path: '/контрагенты/типы/добавить',
        name: 'CompanyTypeCreate',
        ...component('CompanyType', 'detail'),
      },
      {
        path: '/контрагенты/типы/:id',
        name: 'CompanyTypeDetail',
        ...component('CompanyType', 'detail'),
      },
      {
        path: '/контрагенты/добавить',
        name: 'ContractorCreate',
        ...component('Contractor', 'detail'),
      },
      {
        path: '/контрагенты/:id',
        name: 'ContractorDetail',
        ...component('Contractor', 'detail'),
      },
    ],
  },
  {
    name: 'Компании',
    icon: 'mdi-domain',
    root: {
      path: '/компании',
      name: 'CompanyList',
      ...component('company'),
    },
    subRoutes: [],
    routes: [
      {
        path: '/компании/добавить',
        name: 'CompanyCreate',
        ...component('Company', 'detail'),
      },
      {
        path: '/компании/:id',
        name: 'CompanyDetail',
        ...component('Company', 'detail'),
      },
    ],
  },
  {
    name: 'Отделы',
    icon: 'mdi-account-supervisor-circle',
    root: {
      path: '/отделы',
      name: 'DepartmentList',
      meta: { icon: 'mdi-account-supervisor-circle' },
      ...component('Department'),
    },
    subRoutes: [],
    routes: [
      {
        path: '/отделы/добавить',
        name: 'DepartmentCreate',
        ...component('Department', 'detail'),
      },
      {
        path: '/отделы/:id',
        name: 'DepartmentDetail',
        ...component('Department', 'detail'),
      },
    ],
  },
  {
    name: 'Должности',
    icon: 'mdi-account-cash',
    root: {
      path: '/должности',
      name: 'PositionList',
      ...component('Position'),
    },
    subRoutes: [],
    routes: [
      {
        path: '/должности/добавить',
        name: 'PositionCreate',
        ...component('Position', 'detail'),
      },
      {
        path: '/должности/:id',
        name: 'PositionDetail',
        ...component('Position', 'detail'),
      },
    ],
  },
  {
    name: 'Сотрудники',
    icon: 'mdi-account-group',
    root: {
      path: '/сотрудники',
      name: 'EmployeeList',
      ...component('Employee'),
    },
    subRoutes: [
      {
        path: '/сотрудники/роли',
        name: 'RoleList',
        meta: { title: 'Роли' },
        ...component('Role'),
      },
    ],
    routes: [
      {
        path: '/сотрудники/добавить',
        name: 'EmployeeCreate',
        ...component('Employee', 'detail'),
      },
      {
        path: '/сотрудники/:id',
        name: 'EmployeeDetail',
        ...component('Employee', 'detail'),
      },
      {
        path: '/сотрудники/роли/добавить',
        name: 'RoleCreate',
        ...component('Role', 'detail'),
      },
      {
        path: '/сотрудники/роли/:id',
        name: 'RoleDetail',
        ...component('Role', 'detail'),
      },
    ],
  },
  {
    name: 'Задачи',
    icon: 'mdi-clock',
    root: {
      path: '/задачи/:year?/:week?/:userId?',
      name: 'LaborTree',
      ...component('labor', 'tree'),
    },
    routes: [],
    subRoutes: [],
  },
  /*{
    name: 'Документы',
    icon: 'mdi-file-document',
    root: {
      path: '/документы',
      name: 'DocumentList',
      meta: { icon: 'mdi-file-document' },
      ...component('Document'),
    },
    subRoutes: [],
    routes: [
      {
        path: '/документы/добавить',
        name: 'DocumentCreate',
        ...component('Document', 'detail'),
      },
      {
        path: '/документы/:id',
        name: 'DocumentDetail',
        ...component('Document', 'detail'),
      },
    ],
  },
  {
    name: 'Файлы',
    icon: 'mdi-content-save',
    root: {
      path: '/файлы',
      name: 'FileList',
      ...component('file'),
    },
    subRoutes: [],
    routes: [
      {
        path: '/файлы/добавить',
        name: 'FileCreate',
        ...component('file', 'detail'),
      },
    ],
  },*/
] as const;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...Object.values(routes).flatMap((item) => [
      ...item.subRoutes,
      ...item.routes,
      item.root,
    ]),
  ],
});

export const getTitleFromRouteName = (routeName: string) => {
  const route = routes.find(({ root, routes: mainRoutes, subRoutes }) =>
    [root, ...mainRoutes, ...subRoutes].find(({ name }) => name === routeName),
  );
  return route ? route.name : '';
};
router.beforeEach((to: Route, from: Route, next: () => void) => {
  document.title = to.name
    ? `${getTitleFromRouteName(to.name)} - Bustion`
    : 'Bustion';
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    next();
  } else {
    next();
  }
});
export default router;
